/**
 * App-wide configuration constants.
 *
 * `clinicName` is the single place to change the application name shown
 * in headings, login brand, and PDF exports. A future tenant story can
 * read this from the backend instead of hard-coding it.
 */
export const APP_NAME = "Pediatrack";
export const APP_TAGLINE = "Public Health Monitoring for Maternal & Child Care";

export const config = {
    clinicName: APP_NAME,
    tagline: APP_TAGLINE,
    pdf: {
        author: "Pediatrack",
        subject: "Child health record",
        creator: "Pediatrack",
    },
};

export default config;
